(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/login-button.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/login-button.js');

'use strict';

const {
  login
} = svs.components.customer_login;
const Button = svs.ui.ReactButton;
const {
  preventDoubleClick
} = svs.components.lbUtils;
const LoginButton = _ref => {
  let {
    isVisible,
    label
  } = _ref;
  return isVisible && React.createElement("div", {
    className: "overview-hero-button-container"
  }, React.createElement(Button, {
    className: "button-200 qa-competition-overview-hero-login-button",
    onClick: preventDoubleClick(login)
  }, label));
};
LoginButton.defaultProps = {
  label: 'Logga in eller bli kund'
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.LoginButton', LoginButton);

 })(window);